import { Grid, WithStyles, withStyles } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { userStyles } from "../styles";
import _ from 'lodash';
import ContentPreview from "../../mylibrary/containers/ContentPreview";
import ContentCreate from "../../mylibrary/containers/ContentCreate";


interface RequestReviewContainerProps
  extends WithStyles<typeof userStyles> {
    contentId: string,
    contentRequestId: string,
    sliderData: any,
    contentChanged: Function,
    closeReviewContainer: Function;
    currentQuestionNumber: number,
    currentTestNumber: number,
    authorType: string,
    contentQuestionType: string,
    contentQuestionCode: string,
    fromURL: string
}
interface RequestReviewContainerState {
  matchParam: any
}

class RequestReviewContainerContainer extends Component<
  RequestReviewContainerProps,
  RequestReviewContainerState
> {
  constructor(props: RequestReviewContainerProps) {
    super(props);
    this.state = {
      matchParam: {}
    };
    this.handleEditFromFeedback = this.handleEditFromFeedback.bind(this)
    this.handlePreviewFromFeedback = this.handlePreviewFromFeedback.bind(this);
  }

  componentDidMount() {
  }
  componentDidUpdate(prevProps: any) {
    if(prevProps.contentId !== this.props.contentId) {
      if(this.props.fromURL === 'edit') {
      let match = {
        params: {
           contentId: this.props.contentId,
           subType: this.props.contentQuestionCode.toString(),
           type: this.props.contentQuestionType ? this.props.contentQuestionType : "testpapers"
        }
      }
      this.setState({
        matchParam: match
      })
    } else {
      this.setState({
        matchParam: {}
      })
    }
  }
  }
 handleEditFromFeedback(content: any) {
    let match = {
      params: {
         contentId: content._id,
         subType: content.contentSubTypeCode.toString(),
         type: content.contentTypeCode
      }
    }
    this.setState({
      matchParam: match
    })
  }
  handlePreviewFromFeedback() {
    this.setState({
      matchParam: {}
    })
  }

  render() {
    const { classes, contentId, contentRequestId, sliderData, currentQuestionNumber, currentTestNumber, authorType, fromURL } = this.props;
    let match = {
      params: {
        id: contentId
      }
    }

    return (<div>
    {_.isEmpty(this.state.matchParam) &&
      <ContentPreview authorType={authorType}
      handleEditFromFeedback={this.handleEditFromFeedback}
      match={match} fromFeedback={true} prevPath={window.location.pathname} 
      currentTestNumber={currentTestNumber} contentRequestId={contentRequestId} 
      sliderData={sliderData} onContentChange={this.props.contentChanged} 
      currentQuestionNumber={currentQuestionNumber} fromURL={fromURL}
      closeReviewContainer={this.props.closeReviewContainer}/>
    }
        {!_.isEmpty(this.state.matchParam) &&
        <ContentCreate authorType={authorType}
        handleEditFromFeedback={this.handleEditFromFeedback}
        match={this.state.matchParam} fromFeedback={true} prevPath={window.location.pathname} 
        currentTestNumber={currentTestNumber} contentRequestId={contentRequestId} 
        sliderData={sliderData} onContentChange={this.props.contentChanged} 
        handlePreviewFromFeedback={this.handlePreviewFromFeedback}
        currentQuestionNumber={currentQuestionNumber} fromURL={fromURL}
        closeReviewContainer={this.props.closeReviewContainer}/>
         }
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
});

const mapDispatchToProps = {
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(userStyles)(RequestReviewContainerContainer));
